export interface Car {
  id: number;
  dealer_city: string;
  brand: string;
  type_hr: string;
  family: string;
  model_designation: string;
  vin: string;
  dealer: string;
  fuel_hr: string;
  co2_hr: string;
  model_engine: string;
  transmission_type: string;
  color_f: string;
  color_conditional: string;
  color_design: string;
  trim_design: string;
  options: string;
  link: string;
  price_list: string;
  foto1: string;
  foto2: string;
  foto3: string;
  foto4: string;
  equipment_with_pdv: string;
  price_with_pdv: string;
  ppmv: string;
  customer_price_final: string;

  gear_type: string;
  akcija_text1: string;
  akcija_text2: string;
  akcija_text3: string;
  vehicle_state_hr: string;
  idle_days_total: number;
  mask_price_akcija: string;
  mask_price: string;
  mask_price_note: string;
  vehicle_state_detail: string;
  dealer_number: string;
  mask_potrosnja: string;
  equipment_description: string;
  equipment_sort: string;
}

export interface CarWithDealer {
  id: number;
  dealer_city: string;
  brand: string;
  type_hr: string;
  family: string;
  model_designation: string;
  vin: string;
  dealer: Dealer;
  fuel_hr: string;
  co2_hr: string;
  model_engine: string;
  transmission_type: string;
  color_f: string;
  color_conditional: string;
  color_design: string;
  trim_design: string;
  options: string;
  link: string;
  price_list: string;
  foto1: string;
  foto2: string;
  foto3: string;
  foto4: string;
  equipment_with_pdv: string;
  price_with_pdv: string;
  ppmv: string;
  customer_price_final: string;
  gear_type: string;
  akcija_text1: string;
  akcija_text2: string;
  akcija_text3: string;
  vehicle_state_hr: string;
  idle_days_total: number;
  mask_price_akcija: string;
  mask_price: string;
  mask_price_note: string;
  vehicle_state_detail: string;
  dealer_number: string;
  mask_potrosnja: string;
  equipment_description: string;
  equipment_sort: string;
}

export type CarList = Car[];

export interface SimilarVehicle {
  id: number;
  brand: string;
  family: string;
  price: string;
  link: string;
  type_hr: string;
  color_f: string;
  color_design: string;
  trim_design: string;
  partner: string;
}

export interface Dealer {
  name: string;
  city: string;
  street: string;
  postal_code: string;
  efit_id: string;
  url: string;
  working_hours: {
    monday: string;
    tuesday: string;
    wednesday: string;
    thursday: string;
    friday: string;
    saturday: string;
    sunday: string;
  };
}

export interface Vehicle {
  vehicle: CarWithDealer;
  similar_vehicles: CarWithDealer[];
  dealer_vehicles: CarWithDealer[];
}

export const vehicleInitialize: Vehicle = {
  vehicle: {
    id: 0,
    dealer_city: "",
    brand: "",
    type_hr: "",
    family: "",
    model_designation: "",
    vin: "",
    dealer: {
      name: "",
      city: "",
      street: "",
      postal_code: "",
      efit_id: "",
      url: "",
      working_hours: {
        monday: "",
        tuesday: "",
        wednesday: "",
        thursday: "",
        friday: "",
        saturday: "",
        sunday: "",
      },
    },
    fuel_hr: "",
    co2_hr: "",
    model_engine: "",
    transmission_type: "",
    color_f: "",
    color_conditional: "",
    color_design: "",
    trim_design: "",
    options: "",
    link: "",
    price_list: "",
    foto1: "",
    foto2: "",
    foto3: "",
    foto4: "",
    equipment_with_pdv: "",
    price_with_pdv: "",
    ppmv: "",
    customer_price_final: "",
    gear_type: "",
    akcija_text1: "",
    akcija_text2: "",
    akcija_text3: "",
    vehicle_state_hr: "",
    idle_days_total: 0,
    mask_price_akcija: "",
    mask_price: "",
    mask_price_note: "",
    vehicle_state_detail: "",
    dealer_number: "",
    mask_potrosnja: "",
    equipment_description: "",
    equipment_sort: "",
  },
  similar_vehicles: [],
  dealer_vehicles: [],
};
